// extracted by mini-css-extract-plugin
module.exports = {"homePage":"Home_homePage__2Cd0T"};